import { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import FilesModule from "../../../Modules/FilesModule"

import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"

const bossSlayerVariables = [
    {name:'Output', key:'output', type:'W'},
    {name:'Current Attacker', key:'attacker', type:'W'}
]

const bossSlayerFiles = [
    {name:'Health 100%', key:'health_100'},
    {name:'Health 75%', key:'health_75'},
    {name:'Health 50%', key:'health_50'},
    {name:'Health 25%', key:'health_25'},
    {name:'Health 0%', key:'health_0'}
]

export default function BossSlayer( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    // Behaviour 
    const [ hashtag, setHashtag ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)
    
    const [ maxHealth, setMaxHealth ] = useState(null)
    const [ baseDamage, setBaseDamage ] = useState(null)
    const [ criticalDamage, setCriticalDamage ] = useState(null)
    const [ criticalChance, setCriticalChance ] = useState(null)
    const [ winnerSelection, setWinnerSelection ] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ files, setFiles ] = useState(null)


    const requiredData = [
        hashtag,
        hashtagRate, 
        maxHealth,
        baseDamage,
        criticalDamage,
        criticalChance,
        winnerSelection,
        font,
        variables,
        files
    ]

    const cfgName = "kingmaker_boss_slayer_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {} 

        setHashtag( cfg.hashtag || "" )  
        setHashtagRate( cfg.hashtag_rate || "one_per_user" )
        setMaxHealth( (cfg.max_health != null) ? cfg.max_health : 1000 )
        setBaseDamage( (cfg.base_damage != null) ? cfg.base_damage : 1 )
        setCriticalDamage( (cfg.critical_damage != null) ? cfg.critical_damage : 50 )
        setCriticalChance( (cfg.critical_chance != null) ? cfg.critical_chance : 0.05 )
        setWinnerSelection( cfg.winner_selection || "last_blow" )

        setFont( cfg.font || {})
        setVariables( cfg.variables || {} )
        setFiles( cfg.files || {} )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables
        data.files = files

        data.hashtag = hashtag
        data.hashtag_rate = hashtagRate 
        data.max_health = maxHealth 
        data.base_damage = baseDamage 
        data.critical_damage = criticalDamage 
        data.critical_chance = criticalChance 
        data.winner_selection = winnerSelection

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, hashtagRate, maxHealth, baseDamage, criticalDamage, 
        criticalChance, winnerSelection, font, variables, files ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Hit hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                   ]}
                /> 
                <Basic.PositiveIntegerInput name="Max health"
                                            value={maxHealth}
                                            setValue={setMaxHealth}
                />
                <Basic.PositiveIntegerInput name="Base damage"
                                            value={baseDamage}
                                            setValue={setBaseDamage}
                />
                <Basic.PositiveIntegerInput name="Critical Damage"
                                            value={criticalDamage}
                                            setValue={setCriticalDamage}
                />
                <Basic.FloatInput name="Critical Chance"
                                  value={criticalChance}
                                  setValue={setCriticalChance} 
                />
                <Basic.SelectInput name="Winner" value={winnerSelection} setValue={setWinnerSelection} 
                                   options={[
                                        { label: "Last blow", value: "last_blow" },
                                        { label: "Most Damage", value: "most_damage" },
                                   ]}
                /> 
            </SettingsGroup>
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            /> 
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={bossSlayerVariables}
                            reset={reset}
            />
            <FilesModule files={files} 
                         setFiles={setFiles}
                         filesList={bossSlayerFiles}
                         reset={reset}
            />
        </>
    )
}

